import { type FC } from "react";
import { Checkbox } from "@root/shared/components/Checkbox";
import * as styles from "./styles.css";

type Props = {
  clientName: string;
  brandName: string;
  workTitle: string;
  jobEntryId: number;
  disabled: boolean;
  checked: boolean;
  isSp: boolean;
  isError: boolean;
  handleChangeEntryClient: (jobEntryId: number) => void;
  name: string;
};

export const JobEntryCheckbox: FC<Props> = ({
  clientName,
  brandName,
  workTitle,
  jobEntryId,
  disabled,
  checked,
  isSp,
  isError,
  handleChangeEntryClient,
  name,
}) => {
  const deviceType = isSp ? "sp" : "pc";
  const truncateTitle = (str: string) => {
    if (str.length <= 23) return str;
    return `${str.slice(0, 23 - 3)}...`;
  };

  return (
    <label className={styles.label[deviceType]} htmlFor={`job_entry-${jobEntryId}`}>
      <div className={styles.inputBox[deviceType]}>
        <Checkbox
          name={name}
          value={jobEntryId}
          checked={checked}
          disabled={disabled}
          id={`job_entry-${jobEntryId}`}
          hasError={isError}
          onChange={() => handleChangeEntryClient(jobEntryId)}
        />
      </div>
      <div className={styles.jobEntryInfo[deviceType]}>
        <p className={styles.jobEntrySubInfo}>企業名：{clientName}</p>
        <p className={styles.jobEntrySubInfo}>ブランド名：{brandName}</p>
        <p className={styles.workTitle[deviceType]}>
          {isSp ? truncateTitle(workTitle) : workTitle}
        </p>
      </div>
    </label>
  );
};
